import Welcome from './components/welcome.vue';
import Template from './components/template.vue'; 

export const routes = [
	{name: 'template', path: '/', component: Template},
	{name: 'welcome', path: '/welcome', component: Welcome},
 	

]; 


// WEBPACK FOOTER //
// ./src/routes.js